export default "__VITE_PUBLIC_ASSET__7f0cd086__"